import { flowUtils } from '@atlassian/mpac-utils';
export function foldSubscriptionPeriod(subscriptionPeriod, monthly, annual) {
  switch (subscriptionPeriod) {
    case 'monthly':
      return monthly();
    case 'annual':
      return annual();
    default:
      throw flowUtils.unexpectedCase(subscriptionPeriod);
  }
}